'use client';
import styled from 'styled-components';
import { timingSlower } from '../../../constants';
import { fadeIn } from '../keyframes';
export const FadeIn = styled.div `
  animation: ${fadeIn} ${timingSlower} ease 0s 1 both;
`;
//# sourceMappingURL=styles.js.map